import { render, staticRenderFns } from "./purchaseReturnReport.vue?vue&type=template&id=842f411a"
import script from "./purchaseReturnReport.vue?vue&type=script&lang=js"
export * from "./purchaseReturnReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports